import { OptionRequest } from 'packages/sports/web/app/src/navigation-core/pick-uri.model';

import { IAffiliateLink } from '../affiliate.model';

export interface IAffiliateState {
    optionRequest?: OptionRequest | null;
    pendingPicks: string[];
    addedPicks: string[];
    failedPicks: string[];
    affiliateLink: IAffiliateLink | null;
    openedBetslip: boolean;
}

export const defaultAffiliateState = Object.freeze({
    optionRequest: null,
    pendingPicks: [],
    addedPicks: [],
    failedPicks: [],
    affiliateLink: null,
    openedBetslip: false,
}) as IAffiliateState;
